import React from 'react'

const LogList = props => {
  if (!props.logs) {
    return (
      <div className='broad'>Loading...</div>
    );
  }

  if (props.logs.length === 0) {
    return (
      <div className='empty'>
        No log items...
      </div>
    );
  }

  return (
    <div>
      <table className="dataTable">
        <thead>
          <tr>
            <th>created</th>
            <th>type</th>
            <th>user</th>
            <th>recipient</th>
            <th>value</th>
            <th>ip</th>
          </tr>
        </thead>
        <tbody>
        {
          props.logs.map(log => {
            return (
              <tr key={log.id}>
                <td>{log.created}</td>
                <td>{log.type}</td>
                <td>{log.userkey}</td>
                <td>{log.recipient}</td>
                <td>{log.value && typeof(log.value) === 'object' && log.value.$numberDecimal ? log.value.$numberDecimal : log.value }</td>
                <td>{log.ip}</td>
              </tr>
            )
          })
        }
        </tbody>
      </table>
    </div>
  );
};

export default LogList;



// WEBPACK FOOTER //
// ./src/components/widgets/LogList.js